<template>
  <div class="wrapper">
    <section class="section">
      <div class="main main-raised" :style="{ margin: 16 + 'px' }">
        <div class="container">
          <h2 class="text-9 text-center">Legal Notice</h2>

          <p>
            <b>
              Lorem ipsum
            </b>
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia enim
            placeat numquam veritatis animi vitae sit deleniti libero ipsa earum
            voluptate, quasi vel mollitia praesentium ab dolorum atque odit
            impedit.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
